// Generated by @sgflabs/opticomm-sdk-codegen. Do not edit.
// Run `yarn workspace @sgflabs/opticomm-sdk-codegen generate` after changing a backend route.
import { buildPath } from "../../core/path.js";
export const createAdminSampleRequests = (client) => ({
    /**
     * `POST /admin/sample-requests/:id/approve`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminApproveSampleRequest
     * @source packages/modules/b2c-core/src/api/admin/sample-requests/[id]/approve/route.ts
     */
    approve: (id, body, query, headers) => client.fetch(buildPath("/admin/sample-requests/:id/approve", [id]), { method: "POST", body, query, headers }),
    /**
     * `POST /admin/sample-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminCreateSampleRequestForVendor
     * @source packages/modules/b2c-core/src/api/admin/sample-requests/route.ts
     */
    create: (body, query, headers) => client.fetch("/admin/sample-requests", { method: "POST", body, query, headers }),
    /**
     * `GET /admin/sample-requests`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSampleRequestsList
     * @source packages/modules/b2c-core/src/api/admin/sample-requests/route.ts
     */
    list: (query, headers) => client.fetch("/admin/sample-requests", { method: "GET", query, headers }),
    /**
     * `GET /admin/sample-requests/:id`
     *
     * The response is not yet typed — pass a type argument to narrow it,
     * or add an entry to TYPE_OVERRIDES in the codegen package.
     *
     * @operationId AdminSampleRequestsRetrieve
     * @source packages/modules/b2c-core/src/api/admin/sample-requests/[id]/route.ts
     */
    retrieve: (id, query, headers) => client.fetch(buildPath("/admin/sample-requests/:id", [id]), { method: "GET", query, headers }),
});
//# sourceMappingURL=sample-requests.js.map